import React from 'react'
import DynamicFormElements from '../Form/DynamicFormElements'

const formConfigTemplate = [
    /*{
        type: 'officeSelect',
        name: 'officeID'
    },
    {
        type: 'checkbox',
        name: 'includeSubordinatedOffices',
        label: 'includeSubordinatedOffices'
    },*/
    {
        type: 'date',
        name: 'fromPeriode',
        label: 'changesFromPeriode'
    },
    {
        type: 'assetSelect',
        name: 'partnerIDs'
    },
    {
        type: 'checkbox',
        name: 'includeDeactivatedBP',
        label: 'includeDactivatedAsset'
    },
    {
        type: 'checkbox',
        name: 'excludeActivatedBP',
        label: 'excludeActivatedAsset'
    },
    /*{
        type: 'checkbox',
        name: 'includeArticlesWithoutInventory',
        label: 'includeArticlesWithoutInventory'
    },*/
    {
        type: 'articleSelect',
        name: 'articleIDs'
    },
    {
        type: 'text',
        name: 'emailAddress',
        label: 'emailAddress'
    }
]

const AssetInventoryStatistic = ({ formData, setFormData, formErrors }) => {

    return (
        <>
            <DynamicFormElements formConfigTemplate={formConfigTemplate} setFormData={setFormData} formData={formData} formErrors={formErrors} />
        </>
    )
}
export default AssetInventoryStatistic